import styled from 'styled-components';

export const CarouselContainer = styled.div`
    width: 100%;
    min-width: 0;
    margin-bottom: 32px;

    .slick-list {
        overflow: hidden;
    }

    .slick-track {
        display: flex;
        align-items: stretch;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }

    .slick-slide {
        width: 336px !important;
        box-sizing: border-box;
        padding: 0 6px;
    }

    .slick-slide > div {
        height: 100%;
    }

    .slick-dots {
        bottom: -28px;
    }

    .slick-dots li {
        margin: 0 4px;
    }

    .slick-dots li button:before {
        font-size: 8px;
        color: #003c78;
        opacity: 0.45;
    }

    .slick-dots li.slick-active button:before {
        color: #ffca00;
        opacity: 1;
    }

    @media only screen and (max-width: 912px) {
        .slick-slide {
            width: 100% !important;
            padding: 0;
            box-sizing: border-box;
        }

        .slick-slide > div {
            width: 100%;
            height: 100%;

            display: flex;
            justify-content: center;
        }

        .slick-list {
            margin: 0;
        }
    }
`;

export const ExclusiveCarouselContainer = styled(CarouselContainer)`
    .slick-dots li button:before {
        color: #ffffff;
        opacity: 1;
    }

    .slick-dots li.slick-active button:before {
        color: #ffca00;
        opacity: 1;
    }
`;

export const ArrowButton = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    width: 54px;
    height: 53px;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0;

    background: #00a8e9 !important;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    z-index: 20;

    &:hover,
    &:focus {
        background: #008fc7 !important;
        outline: none;
    }

    &:active {
        background: #007eaf !important;
    }

    &::before {
        content: '';
        display: block;
        width: 12px;
        height: 12px;

        border-right: 3px solid #ffffff;
        border-bottom: 3px solid #ffffff;

        box-sizing: border-box;
        opacity: 1;
    }

    &.prev {
        left: -55px;
    }

    &.next {
        right: -55px;
    }

    &.prev::before {
        transform: rotate(135deg);
        margin-left: 5px;
    }

    &.next::before {
        transform: rotate(-45deg);
        margin-right: 5px;
    }

    &.slick-arrow.slick-disabled {
        display: none !important;
    }

    @media only screen and (max-width: 912px) {
        display: none;
    }
`;